<template>
  <client-form :action="createClient" mode="add"/>
</template>
<script>
  import ClientForm from './ClientManagement/ClientForm'
  import ClientService from 'src/services/ClientService'

  export default {
    name: 'client-add',
    components: {
      ClientForm
    },
    methods: {
      async createClient (id, data) {
        let res = await ClientService.create(data)
        this.$router.push({ path: `/contacts/clients/${res.data.uuid}/dashboard#today` })
      }
    }
  }
</script>
<style>
</style>
